{
  "loading": "Loading...",
  "noResults": "No results",
  "clear": "Clear",
  "invalid": "(invalid)",
  "valid": "(valid)"
}
